<template>
  <div>
  	<el-button type="primary" class="addBtn" @click="addMessagePushClick" v-if="auth_control.have_add_auth">新增推送</el-button>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="title"
		      label="系统消息标题"
		      align="center"
        >
		    </el-table-column>

		    <el-table-column
		      prop="create_time"
		      label="添加时间"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      label="操作"
		      align="center"
		      width="160"
        >
         <template slot-scope="scope">
         	  <div class="operation-wrap">
         	    <span class="opration-item" @click="detailMessageClick(scope.row)" v-if="auth_control.have_detail_auth">查看详情</span>
         	    <span class="opration-item" @click="deleteMessageClick(scope.row)" v-if="auth_control.have_delete_auth">删除</span>
         	  </div>
         </template>
		    </el-table-column>
		  </el-table>
    </div>
    <common-dialog
    title="删除"
    :dialogVisible="dialogVisible"
    @cancel="dialogCancelClick"
    @confirm="dialogConfirmClick"
    @dialog-close="dialogClose"
		>
      <div class="dialog-body-wrap">
  		   是否删除系统消息推送？
      </div>
		</common-dialog>
		<common-pagination
	    :total="total"
      :page_size="page_size"
	    @size-change="handelPagesizeChange"
	    @page-change="handlePageChange"
	  ></common-pagination>
  </div>
</template>

<script>
import CommonDialog from '@/components/CommonDialog';
import CommonPagination from '@/components/CommonPagination';
import { messagePushList, deleteMessagePush } from '@/api/content-manage';
import { mapState } from 'vuex';

export default {
  name: 'messagepush',
  data() {
  	return {
      dialogVisible: false,
      tableData: [],
      page_index: '1',  //第几页
  		page_size: '5',
  		total: 0, //总条数
  		handle_row: {},
      auth_control: {
        have_add_auth: false,
        have_detail_auth: false,
        have_delete_auth: false,
      },
      three_rules: [],
  	}
  },
  components: {
  	CommonDialog,
  	CommonPagination
  },
  computed: {
     ...mapState(['operationList']),
  },
  mounted() {
    this.getMessageList();
    this.handleThreeRules();
  },
  methods: {
  	async getMessageList() {
      let postData = {
       	page_index: this.page_index,
       	page_size: this.page_size
      };
      const { status, data } = await messagePushList(postData);
      if ( status !== 200 ) return
      this.tableData = data.data;
      this.total = data.total;
  	},
  	dialogCancelClick() {
      this.dialogVisible = false;
  	},
  	async dialogConfirmClick() {
      const { status } = await deleteMessagePush(this.handle_row.uuid);
      if (status !== 200) return
      this.dialogVisible = false;
  	},
  	dialogClose() {
      this.dialogVisible = false;
      this.getMessageList();
  	},
  	addMessagePushClick() {
      this.$router.push('/message-push/add-message-push')
  	},
  	detailMessageClick(row) {
  		this.$router.push({
  			path:'/message-push/message-detail',
  			query: {
  				uuid: row.uuid
  			}
  		})
  	},
  	deleteMessageClick(row) {
  		this.handle_row = row;
  		this.dialogVisible = true;
  	},
  	handelPagesizeChange(size) {
  		this.page_size = size;
  		this.getMessageList();
  	},
  	handlePageChange(page) {
  		this.page_index = page;
  		this.getMessageList();
  	},
    handleThreeRules() {
      //处理三级权限
      let second_menu_name = this.$route.meta[1].name;
      this.operationList.forEach(item => {
        if (second_menu_name === item.name) {
          this.three_rules = item.operations
        }
      })
      this.three_rules.forEach(item => {
        switch (true) {
          case item.menu_name.indexOf('新增') !== -1:
            this.auth_control.have_add_auth = true;
            break;
          case item.menu_name.indexOf('删除') !== -1:
            this.auth_control.have_delete_auth = true;
            break;
          case item.menu_name.indexOf('详情') !== -1:
            this.auth_control.have_detail_auth = true;
            break;
        }
      })
     console.log(this.three_rules, 'three rulesmessage')
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';
.addBtn {
	float: right;
	margin-bottom: 30px;
}
.table-wrap {
	margin-top: 30px;
	.operation-wrap {
		display: flex;
		justify-content: space-around;
		color: @color-text;
		.opration-item {
			cursor: pointer;
		}
	}
}
.dialog-body-wrap {
	text-align: center;
}
</style>
